import type { ColumnConfig } from '../../../hooks/useColumnConfig';

// MDF-253: column ids match the API row fields, which are also the export keys.
export const ONE_ON_ONE_COLUMNS: ColumnConfig[] = [
  { id: 'participant_name', label: 'Participant', visible: true, sortable: true },
  { id: 'coach_name', label: 'Coach', visible: true, sortable: true },
  { id: 'cohort_name', label: 'Cohort', visible: true, sortable: true },
  { id: 'group_name', label: 'Group', visible: true, sortable: false },
  { id: 'one_on_one_type', label: 'Type', visible: true, sortable: false },
  { id: 'scheduled_start', label: 'Scheduled', visible: true, sortable: true },
  { id: 'status', label: 'Status', visible: true, sortable: true },
  { id: 'absent_reason', label: 'Absence Reason', visible: false, sortable: false },
  { id: 'booked_via', label: 'Booked Via', visible: true, sortable: false },
  { id: 'attendance_notes', label: 'Coach Notes', visible: true, sortable: false, groupable: false },
  { id: 'session_notes', label: 'Session Notes', visible: true, sortable: false, groupable: false },
  { id: 'feedback', label: 'Coach Feedback', visible: true, sortable: false, groupable: false },
  { id: 'engagement_rating', label: 'Engagement', visible: true, sortable: false },
  { id: 'participant_email', label: 'Participant Email', visible: false, sortable: false, groupable: false },
];

export const ONE_ON_ONE_STATUS_OPTIONS = [
  { value: 'completed', label: 'Completed', color: 'green' },
  { value: 'scheduled', label: 'Scheduled', color: 'blue' },
  { value: 'needs_attendance', label: 'Needs attendance', color: 'orange' },
  { value: 'not_scheduled', label: 'Not scheduled', color: 'gray' },
  { value: 'no_show', label: 'No-show', color: 'red' },
  { value: 'canceled', label: 'Canceled', color: 'dark' },
  { value: 'withdrawn', label: 'Withdrawn', color: 'grape' },
] as const;

export const ABSENT_REASON_LABELS: Record<string, string> = {
  business_conflict: 'Business conflict',
  personal_conflict: 'Personal conflict',
  no_notice: 'No notice',
};
